import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import ChatWindow from '../components/ChatWindow.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'ChatWindow',
    component:ChatWindow
  }
]

const router = new VueRouter({
  routes
})

export default router
